import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="blur"
// Blurs the field matching the selector when this element connects, e.g. when
// a Turbo Frame renders a result that should replace what the user typed.
// Usage:
//   <div data-controller="blur" data-blur-selector-value="#consultant_email"></div>
export default class extends Controller {
  static values = { selector: String }

  connect() {
    const field = document.querySelector(this.selectorValue)

    if (field && field === document.activeElement) { field.blur() }
  }
}
